import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class PhotoEditorToolsFontSelectService {

  private showFontSelectListener = new Subject<any>();
  private hideFontSelectListener = new Subject<any>();
  private selectFontListener = new Subject<any>();

  constructor() { }

  public listenShowFontSelect() {
    return this.showFontSelectListener.asObservable();
  }

  public showFontSelect(element?) {
    this.showFontSelectListener.next(element);
  }

  public listenHideFontSelect() {
    return this.hideFontSelectListener.asObservable();
  }

  public hideFontSelect() {
    this.hideFontSelectListener.next();
  }

  public listenSelectFont() {
    return this.selectFontListener.asObservable();
  }

  public selectFont(font) {
    this.selectFontListener.next(font);
  }
}
